module.exports = __webpack_public_path__ + "img/collection.03eec332.svg";